import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Encounter } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ALL_ENCOUNTERS_KEY = 'get-all-encounters';

export const useGetAllEncounters = (
  id: number | undefined,
  { page = 0, size = 1000 }: UseGetAllPageSizeProps,
) => {
  return usePermittedQuery<Encounter[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/encounter/get-encounters/${id}?page=${page}&size=${size}`,
    {},
    [GET_ALL_ENCOUNTERS_KEY],
    {
      enabled: id !== undefined && typeof id === 'number' && id > 0,
      refetchOnWindowFocus: false,
    },
  );
};
